import { AlertDescription, Alert as UIAlert } from '@workspace/ui/components/alert';
import { cn } from '@workspace/ui/lib';
import { CircleAlert, CircleCheck, CircleMinus, Info } from 'lucide-react';
import type { ReactNode } from 'react';

type AlertVariant = 'info' | 'info-pink' | 'error' | 'warning' | 'success';

const iconStyle = 'md:w-4 md:h-4';

const variantIcon: Record<AlertVariant, ReactNode> = {
  info: (
    <Info
      className={cn(iconStyle, 'h-4! w-4! min-w-4! stroke-2! text-blue-600 dark:text-blue-400')}
    />
  ),
  'info-pink': <Info className={cn(iconStyle, 'h-4! w-4! min-w-4! stroke-2! text-pink-400')} />,
  error: (
    <CircleMinus
      className={cn(iconStyle, 'h-4! w-4! min-w-4! stroke-2! text-red-500 dark:text-red-400')}
    />
  ),
  warning: (
    <CircleAlert
      className={cn(iconStyle, 'h-4! w-4! min-w-4! stroke-2! text-orange-600 dark:text-orange-400')}
    />
  ),
  success: (
    <CircleCheck
      className={cn(iconStyle, 'h-4! w-4! min-w-4! stroke-2! text-green-500 dark:text-green-400')}
    />
  ),
};
interface AlertProps {
  description?: string;
  variant?: AlertVariant;
  className?: string;
  descriptionClassName?: string;
  button?: ReactNode;
}
export function Alert({
  description,
  variant = 'info',
  className,
  descriptionClassName,
  button,
}: AlertProps) {
  const icon = variantIcon[variant];
  // 'items-start sm:items-center'
  return (
    <UIAlert className={cn(className, 'xs:items-center xs:flex-row flex-col items-start')}>
      <AlertDescription
        className={cn('flex w-full !items-start justify-start gap-2', descriptionClassName)}
      >
        <div className="flex size-5 items-center justify-center">{icon}</div>
        {description}
      </AlertDescription>
      {button && <div className="xs:ml-auto xs:w-auto ml-0 w-full">{button}</div>}
    </UIAlert>
  );
}
